<template>
  <v-container :class="!isComponent ? 'top-spacer' : ''" style="padding: 0">
    <!-- RETURN BUTTON -->
    <v-row v-if="!isComponent && (isTiroCerteiro() || isBigometro())">
      <v-col style="padding: 0 12px 24px 12px !important">
        <v-btn
          block
          large
          depressed
          color="#D8E0E6"
          class="gray-button pag-btn"
          @click="$router.go(-1)"
        >
          <v-icon size="10" left>$icon-arrow-left</v-icon>Voltar
        </v-btn>
      </v-col>
    </v-row>
    <div class="component-title" v-if="!isComponent">{{ componentTitle }}</div>
    <!-- SELECT BOXES -->
    <v-row>
      <v-col style="padding-bottom: 0">
        <div class="card-label" v-if="isComponent">{{ label }}</div>
        <v-row>
          <v-col style="max-width: 125px; padding: 0 4px 6px 12px">
            <v-select
              @input="applyFilters()"
              :items="tipoPrognostico"
              item-text="name"
              item-value="value"
              v-model="selectedType"
              :class="selectedType"
              placeholder="Tipo"
              hide-details
              background-color="#D8E0E6"
              color="#9aabb8"
              solo
              flat
              height="32px"
            ></v-select>
          </v-col>
          <v-col style="max-width: 125px; padding: 0 4px 6px 4px">
            <v-select
              @input="applyFilters()"
              :items="estadoPrognostico"
              item-text="name"
              item-value="value"
              v-model="selectedStatus"
              :class="selectedStatus"
              placeholder="Estado"
              hide-details
              background-color="#D8E0E6"
              color="#9aabb8"
              solo
              flat
              height="32px"
            ></v-select>
          </v-col>
          <v-col
            style="max-width: 150px; padding: 0 12px 6px 4px"
            v-if="!isTiroCerteiro() && !isBigometro()"
          >
            <v-select
              @input="applyFilters()"
              :items="filtroPrognostico"
              item-text="name"
              item-value="value"
              v-model="selectedFilter"
              :class="selectedFilter"
              placeholder="Filtrar"
              hide-details
              background-color="#D8E0E6"
              color="#9aabb8"
              solo
              flat
              height="32px"
            ></v-select>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <!-- List of PrognosticoCard -->
    <v-row class="prognostic-row" style="overflow: hidden">
      <v-col cols="12">
        <stack
          v-if="items.length > 0"
          :column-min-width="250"
          :gutter-width="15"
          :gutter-height="15"
          monitor-images-loaded
          :key="'stack-' + version"
        >
          <stack-item
            v-for="(matchDetails, index) in items"
            :key="'match-' + index"
            style="transition: transform 300ms"
          >
            <PrognosticoCard
              :matchDetails="matchDetails"
              @open-dialog="openDialog(matchDetails, index)"
              @update-bank="updateBank()"
              @update-list="updateList($event)"
              @bigometro-error="bigometroError()"
            ></PrognosticoCard>
          </stack-item>
        </stack>
        <v-card v-else class="empty-state">
          Não existem jogos a decorrer
        </v-card>
      </v-col>
    </v-row>
    <!-- DIALOG -->
    <v-row justify="center">
      <v-dialog
        v-model="showPrognosticDetails"
        fullscreen
        hide-overlay
        transition="slide-x-reverse-transition"
        content-class="overflow-scroll"
      >
        <PrognosticDetails
          @close-dialog="showPrognosticDetails = false"
          @update-list="updateList($event)"
          @tiro-certeiro-error="tiroCerteiroError($event)"
          :matchDetails="selectedPrognostic"
          :tempMatchDetails="tempSelectedPrognostic"
          :prognosticId="selectedPrognostic.id"
        ></PrognosticDetails>
      </v-dialog>
    </v-row>
    <div>
      <v-btn
        block
        large
        depressed
        color="#D8E0E6"
        class="gray-button pag-btn"
        v-if="isComponent"
        :to="gotToPrognostics()"
        >Ver todos</v-btn
      >
      <v-pagination
        v-model="page"
        :length="totalPages"
        :total-visible="3"
        color="#D8E0E6"
        @click="snackbar = true"
        @input="onPageChange"
      ></v-pagination>
      <v-snackbar v-model="snackbar" timeout="500">{{ page }}</v-snackbar>
    </div>
    <!-- Confirmation Dialog -->
    <!-- SUBMIT DIALOG -->
    <v-dialog v-model="confirmationDialog" max-width="372">
      <v-card>
        <div style="max-width: 100%; margin: 0 !important; padding-top: 32px">
          <v-btn text icon block disabled x-large>
            <v-icon :style="'color: ' + confirmationColor + ' !important;'">{{
              confirmationIcon
            }}</v-icon>
          </v-btn>
        </div>
        <v-card-title
          align="center"
          style="word-break: normal !important"
          v-html="confirmationText"
        >
        </v-card-title>
        <v-list-item style="padding: 0 24px 12px 24px">
          <v-list-item-content>
            <v-btn
              block
              depressed
              dark
              :color="confirmationColor"
              height="48"
              @click="confirmationDialog = false"
              >Continuar</v-btn
            >
          </v-list-item-content>
        </v-list-item>
      </v-card>
    </v-dialog>
    <!-- BIGODDS DIALOG -->
    <v-dialog
      v-model="showBigoddsPrognostics"
      fullscreen
      hide-overlay
      content-class="modal-dialog"
      transition="slide-x-reverse-transition"
    >
      <BigoddsPrognostics
        @close-dialog="showBigoddsPrognostics = false"
        :matchDetails="selectedPrognostic"
      ></BigoddsPrognostics>
    </v-dialog>
  </v-container>
</template>

<style scoped>
.empty-state {
  height: 200px;
  width: 280px;
  text-align: center;
  vertical-align: middle;
  line-height: 200px !important;
  font-family: Gilroy-SemiBold;
  font-size: 12px;
  color: #9aabb8;
}
.pag-btn {
  min-width: 109px !important;
  float: left;
  margin: 5px 8px 0 0;
}
nav {
  float: left;
  max-width: calc(100% - 129px);
}
nav >>> .v-pagination__item {
  margin: 0.3rem 0;
}
nav >>> .v-pagination__navigation {
  margin: 0.3rem 4px;
}
nav >>> li:not(:nth-child(3)) .v-pagination__more {
  display: none;
}
.v-snack >>> .v-snack__wrapper {
  min-width: 40px;
  max-width: 40px;
  min-height: 40px;
  max-height: 40px;
}
@media only screen and (max-width: 1024px) {
  .prognostic-row .col {
    min-width: 33%;
  }
}
@media only screen and (max-width: 768px) {
  .prognostic-row .col {
    min-width: 50%;
  }
}
@media only screen and (max-width: 480px) {
  .prognostic-row .col {
    flex: 0 0 100%;
    max-width: 100%;
  }
}
</style>

<script>
import Vue from "vue";
import { Stack, StackItem } from "vue-stack-grid";

import PrognosticoCard from "@/components/PrognosticoCard.vue";
import PrognosticDetails from "@/components/PrognosticDetails.vue";
import BigoddsPrognostics from "@/components/BigoddsPrognostics.vue";

import ApiService from "../services/api.service";

export default Vue.extend({
  name: "PrognosticList",
  components: {
    Stack,
    StackItem,
    PrognosticoCard,
    PrognosticDetails,
    BigoddsPrognostics,
  },
  props: {
    label: String,
    isComponent: Boolean,
  },
  data: () => ({
    version: 0,
    tipoPrognostico: [
      { name: "Tipo", value: "Tipo" },
      { name: "Simples", value: "simple" },
      { name: "Múltiplo", value: "multiple" },
    ],
    selectedType: "Tipo",
    estadoPrognostico: [
      { name: "Estado", value: "Estado" },
      { name: "Aberto", value: "open" },
      { name: "Fechado", value: "closed" },
    ],
    selectedStatus: "Estado",
    filtroPrognostico: [
      { name: "Filtrar", value: "Filtrar" },
      { name: "Half-Time", value: "halfTime" },
      { name: "Tiro-Certeiro", value: "tiroCerteiro" },
      { name: "Bigómetro", value: "bigometro" },
    ],
    selectedFilter: "Filtrar",
    items: [],
    totalItems: 0,
    totalPages: 0,
    filteredPrognostics: [],
    selectedIndex: null,
    selectedPrognostic: {},
    tempSelectedPrognostic: {},
    showPrognosticDetails: false,
    showBigoddsPrognostics: false,
    page: 1,
    snackbar: false,
    confirmationDialog: false,
    confirmationColor: "#26ab5e",
    confirmationIcon: "$icon-circle-check",
    confirmationText: "",
  }),
  methods: {
    getItems(page, size, filter, type, status) {
      this.loading = true;
      ApiService.getGraphQLPrognostics(page, size, filter, type, status).then(
        (response) => {
          const data = response.data.data.getPrognostics;
          this.items = data.prognostics;
          this.totalItems = data.totalElements;
          this.totalPages = data.totalPages;
          this.version += 1;
          this.loading = false;
        },
        (error) => {
          console.log(
            (error.response && error.response.data) ||
              error.message ||
              error.toString()
          );
        }
      );
    },
    applyFilters() {
      let size;
      const filter = this.$lodash.camelCase(this.selectedFilter);
      this.isComponent ? (size = 4) : (size = 12);
      this.getItems(
        0,
        size,
        this.selectedFilter,
        this.selectedType,
        this.selectedStatus
      );
    },
    openDialog(matchDetails, index) {
      this.tempSelectedPrognostic = this.$lodash.cloneDeep(matchDetails);
      this.selectedPrognostic = matchDetails;
      this.selectedIndex = index;
      if (this.isBigometro()) {
        this.showBigoddsPrognostics = true;
      } else if (this.isTiroCerteiro()) {
        this.showPrognosticDetails = true;
      } else {
        if (matchDetails.tiroCerteiro) {
          this.showPrognosticDetails = true;
        } else if (matchDetails.matchMarkets[0].bigoddsMarkets.length > 0) {
          this.showBigoddsPrognostics = true;
        }
      }
    },
    updateList(params) {
      ApiService.getGraphQLPrognostics(0, 4, params.filter).then((response) => {
        const data = response.data.data.getPrognostics;
        this.items = data.prognostics;
        this.totalItems = data.totalElements;
        this.selectedPrognostic = this.items[this.selectedIndex];
        params.isUpdate
          ? (this.confirmationText =
              "O seu prognóstico foi alterado com sucesso.")
          : (this.confirmationText =
              "<a>Parabéns.</a> O seu prognóstico foi submetido com sucesso.");
        this.confirmationIcon = "$icon-circle-check";
        this.confirmationColor = "#26ab5e";
        this.confirmationDialog = true;
        this.loading = false;
      });
    },
    updateBank() {
      this.$emit("update-bank");
    },
    tiroCerteiroError(subs) {
      this.confirmationText =
        subs < 0
          ? "Não é possível submeter prognósticos após o início do jogo!"
          : "Por favor faça " + subs + " substituições!";
      this.confirmationIcon = "$icon-circle-error";
      this.confirmationColor = "#F83030";
      this.confirmationDialog = true;
    },
    bigometroError() {
      this.confirmationText = "Já esgotou as suas substituições!";
      this.confirmationIcon = "$icon-circle-error";
      this.confirmationColor = "#F83030";
      this.confirmationDialog = true;
    },
    goBack() {
      this.$router.go(-1);
    },
    isTiroCerteiro() {
      return this.$route.path.includes("tiro-certeiro/prognosticos");
    },
    isBigometro() {
      return this.$route.path.includes("bigometro");
    },
    gotToPrognostics() {
      if (this.isTiroCerteiro()) {
        return "/tiro-certeiro/prognosticos";
      } else if (this.isBigometro()) {
        return "/bigometro/prognosticos";
      } else if (this.$route.path.includes("bigometro")) {
        return "/bigometro/prognosticos";
      } else {
        return "/prognosticos";
      }
    },
    onPageChange() {
      console.log(this.page);
    },
  },
  mounted() {
    let size;
    this.isComponent ? (size = 4) : (size = 12);

    if (this.isTiroCerteiro()) {
      this.selectedFilter = "tiroCerteiro";
    } else if (this.isBigometro()) {
      this.selectedFilter = "bigometro";
    }
    this.getItems(0, size, this.selectedFilter, this.selectedType, this.selectedStatus);
  },
  computed: {
    componentTitle() {
      if (this.isTiroCerteiro()) {
        return "Prognósticos Tiro Certeiro";
      }
      if (this.isBigometro()) {
        return "Prognósticos Bigómetro";
      } else {
        return "Prognósticos";
      }
    },
    orderPrognostics() {
      return this.$lodash.orderBy(
        this.items,
        function (e) {
          return e.matchMarkets[0].match.date;
        },
        ["desc"]
      );
    }
  },
  watch: {
    page: function (val) {
      this.snackbar = true;
      this.getItems(
        val - 1,
        this.isComponent ? 4 : 12,
        this.selectedFilter,
        this.selectedType,
        this.selectedStatus
      );
    },
  },
});
</script>
